import React from 'react';
import './PrivacyPolicy.css';
import LegalPage from '../../../components/LegalPage';
import PrivacyPolicyContent from '../../../content/legal/PrivacyPolicyContent';

const PrivacyPolicy = () => (
  <LegalPage
    title="Privacy Policy - Online Waiter"
    updated="16.01.2026"
    publicUrl="https://drive.google.com/file/d/1FVpMGpVkzddpyNi6WrBr3BdVo0aCyHvu/view?usp=drive_link"
    showHeroImage
  >
    <PrivacyPolicyContent />
  </LegalPage>
);

export default PrivacyPolicy;
